import {registerLocaleData} from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import { ApplicationRef, DoBootstrap, NgModule, Type, inject, provideAppInitializer } from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {TranslateHttpLoader, provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {MessageService} from 'primeng/api';
import {Accordion, AccordionHeader, AccordionPanel, AccordionContent} from 'primeng/accordion';
import {Button} from 'primeng/button';
import {DatePicker} from 'primeng/datepicker';
import {Card} from 'primeng/card';
import {Checkbox} from 'primeng/checkbox';
import {ConfirmDialog} from 'primeng/confirmdialog';
import {Dialog} from 'primeng/dialog';
import {Select} from 'primeng/select';
import {Editor} from "primeng/editor";
import {InputNumber} from 'primeng/inputnumber';
import {InputText} from 'primeng/inputtext';
import {MultiSelect} from 'primeng/multiselect';
import {Popover} from 'primeng/popover';
import {RadioButton} from "primeng/radiobutton";
import {TableModule} from 'primeng/table';
import {Tabs, TabList, Tab} from 'primeng/tabs';
import {Toast} from 'primeng/toast';
import {Tooltip} from 'primeng/tooltip';
import {environment} from 'src/environments/environment';
import {AdministrationComponent} from './administration/administration.component';
import {AppRoutingModule} from './app-routing.module';
import {ApplicationComponent} from './application/application.component';
import {AttendeeComponent} from './attendee/attendee.component';
import {AttendeesComponent} from './attendees/attendees.component';
import {LocalizedDatePipe} from './components/LocalizedDatePipe';
import {TrackTypeRenderer} from './components/TrackTypeRenderer';
import {AddZeroWidthSpacePipe} from './components/add-zero-width-space.pipe';
import {TimePipe} from './components/time.pipe';
import {DateDisplayComponent} from './date-display/date-display.component';
import {ErrorRendererComponent} from './error-renderer/error-renderer.component';
import {GeneralConfigComponent} from './general-config/general-config.component';
import {RoomDisplayComponent} from './room-display/room-display.component';
import {RoomsComponent} from './rooms/rooms.component';
import {LocaleService} from './service/locale.service';
import {MiniBookAdminService} from './service/mini-book-admin.service';
import {SimpleEditorComponent} from './simple-editor/simple-editor.component';
import {TimeDisplayComponent} from './time-display/time-display.component';
import {TimeslotsComponent} from './timeslots/timeslots.component';
import {TimetableDisplayComponent} from './timetable-display/timetable-display.component';
import {TimetableEntryComponent} from './timetable-entry/timetable-entry.component';
import {TimetableEntriesComponent} from './timetable-entries/timetable-entries.component';
import { TagsComponent } from './tags/tags.component';
import {Listbox} from 'primeng/listbox';
import {Chip} from 'primeng/chip';
import {Drawer} from 'primeng/drawer';
import {InputIcon} from 'primeng/inputicon';

registerLocaleData(localeDe);



@NgModule({ declarations: [
        AdministrationComponent,
        ApplicationComponent,
        TimeDisplayComponent,
        TrackTypeRenderer,
        LocalizedDatePipe,
        RoomDisplayComponent,
        ErrorRendererComponent,
        DateDisplayComponent,
        TimetableDisplayComponent,
        AddZeroWidthSpacePipe,
        AttendeesComponent,
        AttendeeComponent,
        GeneralConfigComponent,
        TimeslotsComponent,
        RoomsComponent,
        TimetableEntriesComponent,
        TimetableEntryComponent,
        SimpleEditorComponent,
        TimePipe,
        TagsComponent
    ],
    exports: [
        TrackTypeRenderer
    ],
    bootstrap: [], imports: [BrowserModule,
        BrowserAnimationsModule,
        Card,
        Checkbox,
        InputText,
        FormsModule,
        InputNumber,
        Tabs,
        TabList,
        Tab,
        TableModule,
        Button,
        Select,
        DatePicker,
        ConfirmDialog,
        Dialog,
        Tooltip,
        Popover,
        Accordion,
        AccordionPanel,
        AccordionHeader,
        AccordionContent,
        Editor,
        RadioButton,
        Toast,
        AppRoutingModule,
        RouterModule,
        MultiSelect,
        Listbox,
        Chip,
        Drawer,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: TranslateHttpLoader
            }
        })], providers: [
        provideAppInitializer(() => {
        const initializerFn = ((instance: MiniBookAdminService) => () => instance.appInitialize())(inject(MiniBookAdminService));
        return initializerFn();
      }),
        TrackTypeRenderer,
        MessageService,
        provideHttpClient(withInterceptorsFromDi()),
        provideTranslateHttpLoader({
            prefix: environment.deploymentUrl + 'assets/i18n/',
            suffix: '.json'
        })
    ] })
export class AppModule implements DoBootstrap {

  constructor(
    private translate: TranslateService,
    private localeService: LocaleService
  ) {
    this.translate.addLangs(['de', 'en']);
    this.translate.setDefaultLang('de');
  }

  static bootstrapFlex(selector: string, typ: Type<any>, appRef: ApplicationRef): void {
    const nodeList = document.getElementsByTagName('body')[0].querySelectorAll(selector);
    for (let i = 0; i < nodeList.length; i++) {
      appRef.bootstrap(typ, nodeList.item(i));
    }
  }

  ngDoBootstrap(appRef: ApplicationRef): void {
    const language = this.localeService.getCurrentLanguage();
    if (language) {
      this.translate.use(language);
    }
    AppModule.bootstrapFlex('edu-udo-itmc-dev-mini-book-administration', AdministrationComponent, appRef);
    AppModule.bootstrapFlex('edu-udo-itmc-dev-mini-book-application', ApplicationComponent, appRef);
  }

}
